import { AutocompleteRenderGroupParams } from '@mui/material'
import { AutocompleteGroup } from '@omnea-app/omui/BaseAutocomplete'

export const AssigneeAutocompleteGroup = ({ children, group }: AutocompleteRenderGroupParams) => {
  const groupLength = children && Array.isArray(children) ? children.length : 0
  return <AutocompleteGroup label={groupLength > 0 ? `${group} (${groupLength})` : group}>{children}</AutocompleteGroup>
}
